import React, { useState, useEffect } from "react";
import { Typography, Container } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import LoaderContainer from "../../components/LoaderContainer";
import FpoFarmerIcon from "../../assets/Icon/FpoFarmerIcon.png";
import CustomButton from "../../components/Custom/CustomButton";
import { useTranslation } from "react-i18next";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import CustomCard from "../../components/Famer/GenericCard";
import ConfirmationPopup from "../../components/Popup/GenericPopup";

import { useNavigate } from "react-router-dom";
import { useAlert } from "../../components/Alert";
export default function FarmerList() {
  const [fpoDetails, setFPODetails] = useState([]);
  const { showAlert } = useAlert();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);

  useEffect(() => {
    api
      .get(`/fpo/get-fpo-farmer-list/`)
      .then((response) => {
        setFPODetails(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching FPO farmers:", error);
        setLoading(false);
      });
  }, []);

  const handleDelete = (id) => {
    setSelectedMemberId(id);
    setDeleteConfirmationOpen(true);
  };

  const handleConfirmDelete = () => {
    api
      .post(`/fpo/delete-fpo-persona/?farmer_id=${selectedMemberId}`)
      .then((response) => {
        console.log("Farmer deleted successfully", response);
        showAlert("success", "Deleted Successfully");
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error deleting farmer:", error);
        showAlert("error", "Some issue on Deleting the Farmer");
      });
  };
  const handleEditClick = (fpoId) => {
    navigate(`/fpo/farmers/add/?fpoId=${fpoId}`);
  };

  const handleLooginFarmer = (id) => {
    api.post(`/fpo/login-fpo-persona/?persona_user=${id}`).then((response) => {
      const authData = JSON.stringify(response.data);
      window.open(`/login-internal/?authDetails=${authData}`);
    });
  };

  const handleAddFpoMember = () => {
    navigate("/fpo/farmers/add");
  };
  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container
          maxWidth="xs"
          style={{
            height: fpoDetails.length === 0 ? "58vh" : "94vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          {fpoDetails.length !== 0 && (
            <CustomTitle>{t("My Farmers")}</CustomTitle>
          )}
          <div
            style={{
              overflowY: "auto",
              maxHeight: "calc(115vh - 300px)",
              textAlign: "center",
              height: "700px",
              margin: "auto",
            }}
          >
            {fpoDetails.map((fpo) => (
              <CustomCard
                key={fpo.id}
                id={fpo.id}
                t={t}
                data={{
                  [t("Name")]: fpo.app_user.full_name,
                  [t("Username")]: fpo.app_user.user.username,
                  [t("Address")]: fpo.app_user.address,
                  [t("Crops Covered")]: fpo.crops_covered,
                  [t("Aadhar Number")]: fpo.app_user.aadhar_number,
                  [t("Pan Number")]: fpo.app_user.pan_number,
                }}
                handleEditClick={() => handleEditClick(fpo.app_user?.id)}
                handleDelete={() => handleDelete(fpo.app_user?.id)}
                handlePrimaryButton={() => handleLooginFarmer(fpo.app_user?.id)}
                loanData //removing this will enable the threedot menu for edit and delete
                primaryLabel={t("Login")}
              />
            ))}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {fpoDetails.length === 0 && (
              <div style={{ marginBottom: "30px" }}>
                <img
                  src={FpoFarmerIcon}
                  alt="Farmer Icon"
                  style={{
                    width: "127px",
                    height: "127px",
                    // marginBottom: "10px",
                  }}
                />
              </div>
            )}
            <CustomButton onClick={handleAddFpoMember}>
              {t("Add Farmer")}
            </CustomButton>
            {fpoDetails.length === 0 && (
              <Typography variant="subtitle1" sx={{ textAlign: "center" }}>
                {t("Your Farmer will be shown here once you add them.")}
              </Typography>
            )}
          </div>
        </Container>
      </LoaderContainer>
      <ConfirmationPopup
        open={deleteConfirmationOpen}
        handleClose={() => setDeleteConfirmationOpen(false)}
        handleConfirm={handleConfirmDelete}
        title="Confirm Delete"
        message="Are you sure you want to delete this member?"
        confirmButtonText="Delete"
        cancelButtonText="Cancel"
      />
    </>
  );
}
